import styled from 'styled-components';
import {
  border1,
  boxShadow1,
  gray,
  lightBlue,
  lightRed,
  yellow,
} from '../../utils/style/colors';

interface IItemsProp {
  helve: boolean;
}
export const UserItems = styled.ul<IItemsProp>`
  margin: 10px;
  border: ${border1};
  box-shadow: ${boxShadow1};
  border-radius: 10px;
  background-color: ${gray};
  height: 100%;
  overflow: auto;
  padding: 10px !important;
  flex: 1;
  width: ${(props) => {
    return props.helve ? '50%' : '100%';
  }};
`;

interface IItemProp {
  isActive: boolean;
  level?: string;
}

export const Item = styled.li<IItemProp>`
  width: 100%;
  border: ${border1};
  cursor: pointer;
  margin: 10px;
  display: block;
  padding: 10px 20px;
  position: relative;
  transition: all 0.3s ease;
  box-sizing: border-box;
  align-items: center;
  border-radius: 10px;
  background-color: var(--exact-white);
  color: black;

  ${({ level }) =>
    level === 'error'
      ? `
      background-color: ${lightRed};
  `
      : level === 'warn'
        ? `
      background-color: ${yellow};
  `
        : level === 'info'
          ? `
      background-color: ${lightBlue};
      
  `
          : ''}
  ${({ isActive }) =>
    isActive &&
    `
      border: 1px solid #34c8b6;
      background-color: #dcdcdc;
  `}
`;
